import { render, staticRenderFns } from "./AccountBalance.vue?vue&type=template&id=48090965&scoped=true&"
import script from "./AccountBalance.vue?vue&type=script&lang=ts&"
export * from "./AccountBalance.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBalance.vue?vue&type=style&index=0&id=48090965&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48090965",
  null
  
)

export default component.exports